import React from 'react';
import { InstantSearch } from 'react-instantsearch';
import client from '../../apis/algolia';

interface SharedAlgoliaProviderProps {
  indexName: string;
  children: React.ReactNode;
}

/**
 * Unified Algolia provider that creates a single InstantSearch context
 * for both refinement counts and search results.
 */
export const SharedAlgoliaProvider: React.FC<SharedAlgoliaProviderProps> = ({
  indexName,
  children,
}) => (
  <InstantSearch searchClient={client} indexName={indexName}>
    {children}
  </InstantSearch>
);

export default SharedAlgoliaProvider;
